type DashboardSizeConfiguration = {
	width: number;
	height: number;
};

const defaultSizeConfiguration: DashboardSizeConfiguration = {
	width: 1800,
	height: 950
};

export { defaultSizeConfiguration, DashboardSizeConfiguration };